/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateAutomationForFlowRequest} from '@cash-web/protos/squareup/cash/investautomator/api/flows/updateAutomationForFlow.pb'
import {UpdateAutomationForFlowResponse} from '@cash-web/protos/squareup/cash/investautomator/api/flows/updateAutomationForFlow.pb'


export const updateAutomationForFlow = (request: UpdateAutomationForFlowRequest, options?: CashRequestOptions) => post<UpdateAutomationForFlowRequest, UpdateAutomationForFlowResponse>("/2.0/cash/update-automation-for-flow", request, {...options, rejectOnError: true })